import type { FC } from "react";
import { ElementPosition, GroupOrientation } from "@stubhub/broadway-types";
import { ButtonGroup } from "@stubhub/broadway-web";
import { favButtonWithCountStyle } from "src/website-apps/responsive/stubhub-performer/components/page-header/bleeding-header/styles";
import { usePerformerPageModelData } from "src/website-apps/responsive/stubhub-performer/hooks/usePerformerPageModelData";
import { FavoritesButtonWithCount } from "src/website-apps/shared/components/FavoritesV2Buttons/FavoritesV2Button/FavoritesButtonWithCount";
import {
  ENTITY_TYPES,
  FAVORITES_BUTTON_VARIANTS,
} from "src/website-apps/shared/components/grid/favorites-fs/constants";
import { ShareButton } from "src/website-apps/shared/components/hero-banner/ImmersiveHeroBanner/ImmersiveHeroBanner.styled";
import { SHARING_ORIGINS } from "src/website-apps/shared/components/stubhub-sharing/SharingOrigins";
import { hasPerformerSurfaceEvents } from "src/website-apps/shared/utils/performerGridSurface";

interface Props {
  categoryId?: Maybe<number>;
  categoryName: string;
  aggregateFavorites?: Maybe<number>;
}

// Productionized: SharingFeatureV1 (TM:16995, Deployed Variant 1, StubHub only)
export const ActionButtonsForMobileGlass: FC<Props> = ({ categoryId, categoryName, aggregateFavorites }) => {
  const model = usePerformerPageModelData();
  const hasEvents = hasPerformerSurfaceEvents(model.performerGridSurface);

  return (
    <ButtonGroup orientation={GroupOrientation.Horizontal} position={ElementPosition.End}>
      <FavoritesButtonWithCount
        className={favButtonWithCountStyle}
        stopPropagation
        preventDefault
        variant={FAVORITES_BUTTON_VARIANTS.LIGHT}
        entityType={ENTITY_TYPES.CATEGORY}
        entityId={categoryId}
        aggregateFavorites={aggregateFavorites}
      />

      {hasEvents && <ShareButton sharingOrigin={SHARING_ORIGINS.PERFORMER} data={{ title: categoryName }} />}
    </ButtonGroup>
  );
};
